<template>
  <div class="row row-cols-1 gy-3">
    <div class="col">
      <input
        type="text"
        v-model="description"
        class="form-control form-control-lg"
        placeholder="入力してください。"
        id="description"
      />
      <button
        class="btn btn-lg btn-success w-100 py-3 mt-2"
        v-on:click.prevent="success()"
      >
        <i class="bi bi-check-circle-fill me-2"></i> 入力しました
      </button>
    </div>
  </div>
</template>

<script>
import { toHalfWidth } from '@/utils/stringUtils'

export default {
  name: 'InspectionComparison',

  emits: ['resultFunc'],

  props: {
    inspection_item: {
      type: Object,
      required: true,
    },
  },

  data() {
    return {
      check_count: 0,
      description: null,
    }
  },

  methods: {
    reset() {
      this.check_count = 0
      this.description = null
    },
    success() {
      let is_success = true

      // 入力チェック
      // 空かどうか
      // 入力内容の英数字記号を半角に変換したあと expected_value と比較
      // 異なった場合は expected_check_count の数だけ比較を繰り返す
      // 比較が正しい、または expected_check_count を超えた場合は emit
      if (!this.description || this.description.trim() === '') {
        this.$store.dispatch('alert/setErrorMessage', {
          message: '入力してください。',
        })
        return
      }
      // 半角に変換
      this.description = toHalfWidth(this.description)
      // 比較
      const expectedValue = this.inspection_item.expected_value
      const expectedCheckCount = this.inspection_item.expected_check_count
      if (this.description !== expectedValue) {
        console.log(this.check_count)
        this.check_count++
        if (this.check_count < expectedCheckCount) {
          this.$store.dispatch('alert/setErrorMessage', {
            message: '入力内容が期待値と異なります。',
          })
          return
        } else {
          is_success = false
        }
      }
      console.log('Comparison result:', is_success)
      console.log('Description:', this.description)
      this.$emit('resultFunc', {
        is_success: is_success,
        description: this.description,
        photo: null,
      })
      this.reset()
    },
  },
}
</script>
